enum names {
  Applications = "Applications",
  Audiences = "Audiences",
  Features = "Features",
  RuleEvaluators = "RuleEvaluators",
  Versions = "Versions"
}

export default names;
